angular.module('iqxCore')
    .controller('TimesheetsCtrl', function($scope, $routeParams, $location, FormSvc, ApplicationSvc, ApiSvc) {
        moment.locale('en_gb', {
            week: {
                dow: 1 // Monday is the first day of the week
            }
        })

        /**
         * "start" and "end" should be JS date objects
         **/
        $scope.updateURL = function(start, end) {
            start = moment(start)
            end = moment(end)

            $location.url('/timesheets/' + start.format('YYYY-MM-DD') + '/' + end.format('YYYY-MM-DD'))
        }

        $scope.showRates = $scope.userHasRight('TSSHOWRATES')
        $scope.theRecord = {}

        if (!$routeParams.from || !$routeParams.to) {
            $scope.theRecord.startDateFilter = moment().subtract(6, 'months').toDate()
            $scope.theRecord.endDateFilter = moment().endOf('week').toDate()

            $scope.updateURL($scope.theRecord.startDateFilter, $scope.theRecord.endDateFilter)
        } else {
            $scope.theRecord.startDateFilter = moment($routeParams.from, 'YYYY-MM-DD').toDate()
            $scope.theRecord.endDateFilter = moment($routeParams.to, 'YYYY-MM-DD').toDate()
        }

        $scope.getFiltered = function() {
            $scope.updateURL($scope.theRecord.startDateFilter, $scope.theRecord.endDateFilter)
            FormSvc.setOptions($scope, {
                fetchAPI: 'callresult/nettimesheets?' + ($scope.theRecord.startDateFilter ? 'pStartDate=' + moment($scope.theRecord.startDateFilter).format("YYYY-MM-DD") + '&' : '') + ($scope.theRecord.endDateFilter ? 'pEndDate=' + moment($scope.theRecord.endDateFilter).format("YYYY-MM-DD") : ''),
                dateFields: ['weekenddate'],
                booleanFields: ['awaitsApproval', 'processed'],
                multiRow: true,
                sliceSize: 10,
                autoEdit: true
            })
            $scope.fetch()
                .then(function() {
                    $scope.theRecords.forEach(timesheet => {
                        timesheet.weekstartdate = moment(timesheet.weekenddate).subtract(6, 'd').toDate()
                    })
                })
        }

        $scope.expandTimesheet = function(tsid) {
            $location.url('/timesheet?id=' + tsid)
        }

        $scope.getlang = function(lang) {
            return $scope.params.lang.pages.timesheets.table[lang]
        }

        $scope.getDivisionTimesheetSigningRightsAndTerms = function() {
            return ApiSvc.fetch($scope, {
                    fetchAPI: 'callresult/NetCandidateRegDetails?pPersonID=' + (ApplicationSvc.currentUser.personID || ''),
                    fetchTarget: 'RegDets',
                    multiRow: false,
                    booleanFields: ['DepartmentPerm', 'DepartmentTemp']
                })
                .then(function() {
                    /* Ensure we have these stored. */
                    ApplicationSvc.currentUser.registrationDetails.DivisionID = $scope.RegDets.DivisionID
                    ApplicationSvc.currentUser.registrationDetails.DepartmentID = $scope.RegDets.DepartmentID
                    $scope.useWeekStartDateOnTS = ApplicationSvc.params.behaviour.TSSWEEKSTART
                    $scope.showPosition = ApplicationSvc.params.behaviour.TSSSHOWPOSITION
                })
        }

        if (ApplicationSvc.currentUser.UserClass === "CANDIDATE" && $scope.isSwitchedOn('FETCHCANDTSSET')) {
            $scope.getDivisionTimesheetSigningRightsAndTerms()
                .then($scope.getFiltered)
        } else {
            $scope.getFiltered()
        }
    })